/**
 * Opt-in layout for form sheets.
 *
 * `pipeline` gives every sheet opened from /pipeline the same width and a footer
 * with Cancel on the left and Save on the right. Leaving `layout` unset keeps
 * the classes each sheet has always had, so screens outside the pipeline do not
 * change.
 */
export type SheetLayout = 'default' | 'pipeline'

/** One width for every pipeline sheet; full width below the `sm` breakpoint. */
export const PIPELINE_SHEET_CONTENT_CLASS = 'w-full sm:max-w-xl'

/** Pushes Cancel (first child) left and the primary action (last child) right. */
export const PIPELINE_SHEET_FOOTER_CLASS = 'sm:justify-between'

export function sheetContentClass(layout: SheetLayout | undefined, defaultClass?: string): string | undefined {
  return layout === 'pipeline' ? PIPELINE_SHEET_CONTENT_CLASS : defaultClass
}

export function sheetFooterClass(layout: SheetLayout | undefined): string | undefined {
  return layout === 'pipeline' ? PIPELINE_SHEET_FOOTER_CLASS : undefined
}
